import { Component } from 'react'
import IconSVG from 'svg-inline-react'
import cx from 'classnames'

const volume = require('!svg-inline?removeTags=true!images/svg/volume.svg')
const check = require('!svg-inline?removeTags=true!../../../shared/InlineEditor/images/check-mark.svg')

class EnableSound extends Component {

  constructor(props) {
    super(props)
    this.state = {
      closed: true
    }
  }

  componentDidMount() {
    setTimeout(this.setOpen, 2000)
  }

  componentDidUpdate() {
    if (this.props.sound === 'enabled') {
      setTimeout(this.setClose, 1000)
    }
  }

  setOpen = () => {
    this.setState({closed: false})
  }
  setClose = () => {
    this.setState({closed: true})
  }

  render() {
    return (
      <div className={cx('global-notification-tease', 'instruction', { 'show-bar': !this.state.closed})}>
        {this.props.sound === 'enabled' &&  <p>  <IconSVG src={check} /> Notification sounds enabled </p>}
        {this.props.sound === 'failed' && <p>  <IconSVG src={volume} /> Click anywhere on the page to enable notification sounds</p>}
      </div>
    )
  }
}

export default EnableSound



// WEBPACK FOOTER //
// ./src/scripts/components/GlobalNotificationBar/components/EnableSound/index.js